// extracted by mini-css-extract-plugin
export default {"selectBox":"SelectMultiCheckboxSimple_selectBox__2qJqj","option":"SelectMultiCheckboxSimple_option__ePt3P"};